import { render } from "./BuilderDesktopStepIndicator.vue?vue&type=template&id=3a6fbbba&scoped=true&ts=true&lang=pug"
import script from "./BuilderDesktopStepIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuilderDesktopStepIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./BuilderDesktopStepIndicator.vue?vue&type=style&index=0&id=3a6fbbba&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6fbbba"]])

export default __exports__